import { createApp } from 'vue'
import TDesign from 'tdesign-vue-next';
import App from './App.vue'
import md5 from 'md5'
import router from './router'

// 引入组件库的少量全局样式变量
import 'tdesign-vue-next/es/style/index.css';
import '@/assets/css/common.css';

const app = createApp(App);



router.beforeEach((to, from, next) => {
    /* 路由发生变化修改页面title */
    if (to.meta.title) {
        document.title = to.meta.title
    }
    next()
})


app.use(router)
    .use(md5)
    .use(TDesign)
    .mount('#app');